/*                                                        */
/*                                     */
import { on } from "svelte/events";
import type { Action } from "svelte/action";
import type { useContentScroll } from "./scrollOverflow.svelte";
import { onDestroy } from "../utils/props";
import { sheetClose } from "../apis/methods.js";
import { SHEET_ACTION_DRAG_DOWN } from "../event/event.activation";

const CLOSING_DISTANCE = 100;

/**
 *
 *
 *
 *
 *
 *
 */
export function computeDragStyle(isDragging: boolean, dragDistance: number): string {
  if (!isDragging) return "";

  const dragOffsetY = dragDistance > 0 ? `${dragDistance}px` : "0";
  return `transform:translateY(${dragOffsetY})`;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export const useDragClose = (contentScroll: ReturnType<typeof useContentScroll>) => {
  /*                                                                    */
  let touchStartY = 0;

  /**
 *
 *
 *
 */
  const onTouchEnd = (): void => {
    /*                                                                      */
    /*                                       */
    if (state.isDragging && state.dragDistance > CLOSING_DISTANCE)
      sheetClose({ action: SHEET_ACTION_DRAG_DOWN });

    state.dragDistance = 0;
    state.isDragging = false;
    touchStartY = 0;
  };

  const state = $state({
    /**
 *
 *
 */
    isDragging: false,

    /**
 *
 *
 */
    dragDistance: 0,

    /**
 *
 */
    sheetDragStyle: computeDragStyle(false, 0),

    headerEvents: ((node) =>
      onDestroy(
        on(node, "touchstart", (event) => {
          state.isDragging = true;
          touchStartY = event.touches[0].clientY;
        }),

        on(
          node,
          "touchmove",
          (event) => {
            if (!state.isDragging) return;

            state.dragDistance = event.touches[0].clientY - touchStartY;

            /*                                                     */
            if (event.cancelable) event.preventDefault();
          },

          /*                                                                     */
          { passive: false },
        ),

        on(node, "touchend", onTouchEnd),
      )) as Action,

    contentEvents: ((node) =>
      onDestroy(
        on(node, "touchstart", (event) => {
          if (!contentScroll.isScrolling) touchStartY = event.touches[0].clientY;
        }),

        on(node, "touchmove", (event) => {
          event.stopPropagation();

          /*                                              */
          if (touchStartY <= 0) return;

          state.dragDistance = event.touches[0].clientY - touchStartY;
          /*                                                                                 */
          /*                                                               */
          state.isDragging = !contentScroll.isScrolling && state.dragDistance > 2;

          /*                                                     */
          if (state.isDragging && event.cancelable) event.preventDefault();
        }),
        on(node, "touchend", onTouchEnd),
      )) as Action,
  });

  /*                                                                           */
  $effect(() => {
    state.sheetDragStyle = computeDragStyle(state.isDragging, state.dragDistance);
  });

  return state;
};
